<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Sponsorship Opportunity Selection">
                    <AmountSelectorList/>
                    <ErrorLabel field="amount" />
                    <TransactionFee />
                </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                    </FormRow>
                    <DonorAddress />
                </FormSection>
                <FormSection last title="Payment Information">
                    <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                  <PaymentButton showAmount btnText="Donate"/>
                </FormSection>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">
.form-container.ou-donation-form {
  max-width: 800px;
}
::v-deep h2 {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .amount-row {
  @media (min-width: 720px) {
    min-width: 24%;
    max-width: 24%;
  }
  label {
    padding: 22px 14px 16px;
    flex-direction: column;
    display: flex;
    border-radius: 8px !important;
    border: 2px solid #EBEBEB !important;
    font-size: 14px !important;
    color: #96999C !important;
    &:after {
      color: white;
      content: "Select";
      background: #1e50b4;
      border-radius: 6px;
      text-align: center;
      padding: 12px 32px;
      font-weight: normal;
      max-width: 100px;
      margin: 10px auto 0px;
  }
  }
  input[type=radio]:checked + label {
    border-color: #1E50B4 !important;
    background: white !important;
    color: #080F16 !important;
    .label-amount {
      color: #1E50B4 !important;
    }
  }
  .label-amount {
    color: #080F16 !important;
    background: none !important;
    padding: 0  !important;
    border: none  !important;
    font-size: 24px !important;
    font-weight: 700 !important;
    min-width: 100%;
    text-align: center;
    display: block;
  }
  &.amount_other__wrapper {
    max-width: 49%;
    border-color: #ebebeb !important;
    margin: auto;
    border-width: 2px !important;
}
}
</style>

